import FileDownloadIcon from "@mui/icons-material/FileDownload";
import SendIcon from "@mui/icons-material/Send";
import {
  CircularProgress,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup
} from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DropZone from "../../../commons/dropZone/DropZone";
import { StyledDropzone } from "../../../styled/Dropzone";
import { StyledNominaContainer } from "../../../styled/Personal";
import NominaEmailDialog from "./NominaEmailDialog";
import NominaTable from "./NominaTable";

const NominaContainer = ({ handleSubmit }) => {

  const descargarCertificado = useSelector(
    (state) => state.certificadoCobertura.descargar
  );
  const enviarCertificado = useSelector(
    (state) => state.certificadoCobertura.enviarMail
  );
  const validarNominas = useSelector(
    (state) => state.certificadoCobertura.validarNominas
  );

  const [value, setValue] = useState(null);
  const [nominasSelected, setNominasSelected] = useState({});
  const [nominaFile, setNominaFile] = useState(null);
  const [openSendEmail, setOpenSendEmail] = useState(false);

  const disabled =
    enviarCertificado.loading === true ||
    descargarCertificado.loading === true ||
    validarNominas.loading === true ||
    value === null ||
    (value === "3" && Object.keys(nominasSelected).length === 0) ||
    (value === "4" && (nominaFile === null || nominaFile?.length <= 0));

  useEffect(() => {
    if (value !== "3") {
      setNominasSelected({});
    }
    if (value !== "4") {
      setNominaFile(null);
    }
  }, [value]);

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleSendEmail = (email) => {
    handleSubmit(email, value, Object.keys(nominasSelected), nominaFile);
  };

  return (
    <StyledNominaContainer.Container>
      <StyledNominaContainer.ContentContainer>
        <FormControl>
          <RadioGroup
            name="nomina"
            onChange={handleChange}
            value={value}
            sx={{ rowGap: "1vw" }}
          >
            <FormControlLabel
              value="1"
              control={<Radio color="primary" />}
              label="Sin nómina"
            />
            <FormControlLabel
              value="2"
              control={<Radio color="primary" />}
              label="Todas las nóminas"
            />
            <FormControlLabel
              value="3"
              control={<Radio color="primary" />}
              label="Selección de nóminas"
            />
            <FormControlLabel
              value="4"
              control={<Radio color="primary" />}
              label="Importar selección de nóminas"
            />
          </RadioGroup>
        </FormControl>
        {value === "3" && (
          <NominaTable
            nominasSelected={nominasSelected}
            setNominasSelected={setNominasSelected}
          />
        )}
        {value === "4" && (
          <StyledDropzone.ExternalContainer>
            <DropZone
              file={nominaFile}
              setFile={setNominaFile}
              loading={false}
              extension=".csv, .xls o .txt"
              accept={{
                "text/csv": [".csv"],
                "application/vnd.ms-excel": [".xls"],
                "text/plain": [".txt"],
              }}
              dropZoneText="Arrastre aquí o haga click en el recuadro para importar la nómina en formato xls, cvs o lista de CUILs."
              dropZoneEditText="Si desea cambiar el archivo arrastrelo nuevamente o haga click en
        el recuadro."
            />
          </StyledDropzone.ExternalContainer>
        )}
      </StyledNominaContainer.ContentContainer>
      <StyledNominaContainer.ButtonContainer>
        <StyledNominaContainer.Button
          variant="contained"
          color="primary"
          endIcon={<SendIcon />}
          disabled={disabled}
          onClick={() => setOpenSendEmail(true)}
        >
          {enviarCertificado.loading || validarNominas.loading ? (
            <CircularProgress size={24} thickness={4} color="secondary" />
          ) : (
            "Enviar certificado de cobertura"
          )}
        </StyledNominaContainer.Button>
        <StyledNominaContainer.Button
          variant="contained"
          color="primary"
          endIcon={<FileDownloadIcon />}
          disabled={disabled}
          onClick={() => handleSubmit(null, value, Object.keys(nominasSelected), nominaFile)}
        >
          {descargarCertificado.loading || validarNominas.loading ? (
            <CircularProgress size={24} thickness={4} color="secondary" />
          ) : (
            "Descargar certificado de cobertura"
          )}
        </StyledNominaContainer.Button>
      </StyledNominaContainer.ButtonContainer>
      <NominaEmailDialog
        open={openSendEmail}
        handleClose={() => setOpenSendEmail(false)}
        handleSubmit={handleSendEmail}
      />
    </StyledNominaContainer.Container>
  );
};

export default NominaContainer;
